export default [
  // TOP 20 Best Fonts
  { id: 1, label: 'Sora', value: 'Sora' },
  { id: 2, label: 'Hahmlet', value: 'Hahmlet' },
  { id: 3, label: 'JetBrains Mono', value: 'JetBrains Mono' },
  { id: 4, label: 'Andada Pro', value: 'Andada Pro' },
  { id: 5, label: 'Epilogue', value: 'Epilogue' },
  { id: 6, label: 'Inter', value: 'Inter' },
  { id: 7, label: 'Encode Sans', value: 'Encode Sans' },
  { id: 8, label: 'Manrope', value: 'Manrope' },
  { id: 9, label: 'Lora', value: 'Lora' },
  { id: 10, label: 'BioRhyme', value: 'BioRhyme' },
  {
    id: 11,
    label: 'Playfair Display',
    value: 'Playfair Display'
  },
  { id: 12, label: 'Archivo', value: 'Archivo' },
  { id: 13, label: 'Roboto', value: 'Roboto' },
  { id: 14, label: 'Cormorant', value: 'Cormorant' },
  { id: 15, label: 'Spectral', value: 'Spectral' },
  { id: 16, label: 'Raleway', value: 'Raleway' },
  { id: 17, label: 'Work Sans', value: 'Work Sans' },
  { id: 18, label: 'Lato', value: 'Lato' },
  { id: 19, label: 'Anton', value: 'Anton' },
  {
    id: 20,
    label: 'Old Standard TT',
    value: 'Old Standard TT'
  },
  { id: 21, label: 'Oswald', value: 'Oswald' },
  { id: 22, label: 'Montserrat', value: 'Montserrat' },
  { id: 23, label: 'Poppins', value: 'Poppins' },
  { id: 24, label: 'Nunito', value: 'Nunito' },
  {
    id: 25,
    label: 'Source Sans Pro',
    value: 'Source Sans Pro'
  },
  { id: 26, label: 'Oxygen', value: 'Oxygen' },
  { id: 27, label: 'Open Sans', value: 'Open Sans' },
  // 26 Best Cursive Fonts
  { id: 28, label: 'Arizonia', value: 'Arizonia' },
  { id: 29, label: 'Lobster', value: 'Lobster' },
  { id: 30, label: 'Rouge Script', value: 'Rouge Script' },
  { id: 31, label: 'Pacifico', value: 'Pacifico' },
  { id: 32, label: 'Alex Brush', value: 'Alex Brush' },
  {
    id: 33,
    label: 'Kaushan Script',
    value: 'Kaushan Script'
  },
  { id: 34, label: 'Sail', value: 'Sail' },
  { id: 35, label: 'Sacramento', value: 'Sacramento' },
  { id: 36, label: 'Marck Script', value: 'Marck Script' },
  { id: 37, label: 'Sonsie One', value: 'Sonsie One' },
  {
    id: 38,
    label: 'Monsieur La Doulaise',
    value: 'Monsieur La Doulaise'
  },
  { id: 39, label: 'Rock Salt', value: 'Rock Salt' },
  { id: 40, label: 'Rochester', value: 'Rochester' },
  { id: 41, label: 'Rancho', value: 'Rancho' },
  { id: 42, label: 'Croissant One', value: 'Croissant One' },
  { id: 43, label: 'Yesteryear', value: 'Yesteryear' },
  { id: 44, label: 'Courgette', value: 'Courgette' },
  { id: 45, label: 'Sofia', value: 'Sofia' },
  { id: 46, label: 'Allura', value: 'Allura' },
  { id: 47, label: 'Redressed', value: 'Redressed' },
  { id: 48, label: 'Cookie', value: 'Cookie' },
  { id: 49, label: 'Amita', value: 'Amita' },
  { id: 50, label: 'Meie Script', value: 'Meie Script' },
  {
    id: 51,
    label: 'Euphoria Script',
    value: 'Euphoria Script'
  },
  { id: 52, label: 'Tangerine', value: 'Tangerine' },
  { id: 53, label: 'Sevillana', value: 'Sevillana' }
]
